export default __webpack_public_path__ + "static/media/bg.78f1d668.jpg";